<template>
	<div class="relative isolate overflow-visible w-full max-w-3xl mx-auto px-6">
		<div class="pt-12 pb-12 px-4 md:pt-32">
			<h3 class="w-full text-center text-3xl md:text-5xl font-bold text-primary">
				<span class="uppercase">
					{{ $t('login.maverix') }}
				</span> {{ $t('login.customer-login') }}
			</h3>
		</div>
		<AccountLogin />
	</div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import {
BASE_URL, COMPANY_NAME
} from '~/constants/index.js'

const { t } = useI18n({
	useScope: 'global'
})
definePageMeta({
	layout: 'default'
})

useHead({
	title: t('login.meta-title'),
	meta: [
		{ name: 'description',
			content: t('login.description', { COMPANY_NAME }) },
		{ name: 'url',
			content: `${BASE_URL}/login` }
	]
})
</script>
